import axios from 'axios'
import { endAdminSession, getAdminToken } from '../utils/functions/auth'

const urlBase = process.env.REACT_APP_URL_BACKEND_BASE

const authHeaders = () => {
  const token = getAdminToken()
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}

// Las acciones de escritura del panel admin devuelven status 401 dentro del
// body (no como status HTTP) cuando la sesión no es válida o venció.
// Si eso pasa, limpiamos la sesión local para que el próximo cambio de ruta
// mande de nuevo al login.
const handleAuthResponse = response => {
  if (response?.data?.status === 401) {
    endAdminSession()
  }
  return response
}

const getProductById = async id => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`

  url = url.replace(':id', encodeURIComponent(id))
  url = url.replace(':accion', 'productById')

  const response = await axios.get(url)

  return response
}

const getAllProducts = async (page, cantPorPagina, filtroStock) => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`
  url = url.replace(':accion', 'allProducts')
  url = url.replace(':pagina', encodeURIComponent(page))
  url = url.replace(':cantPorPagina', encodeURIComponent(cantPorPagina))
  if (filtroStock && filtroStock !== 'todos') {
    url += `&filtroStock=${encodeURIComponent(filtroStock)}`
  }

  const response = await axios.get(url)

  return response
}

const getProductsByCategory = async (filter, page) => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`
  url = url.replace(':accion', 'productsByCategory')
  url = url.replace(':pagina', encodeURIComponent(page ? page : 1))
  url += `&categoria=${encodeURIComponent(filter)}`

  const response = await axios.get(url)

  return response
}

const addProduct = async product => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`
  url = url.replace(':accion', 'addProduct')

  const response = await axios.post(url, product, authHeaders())

  return handleAuthResponse(response)
}

const editProduct = async product => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`
  url = url.replace(':accion', 'editProduct')

  const response = await axios.post(url, product, authHeaders())

  return handleAuthResponse(response)
}

const deleteProduct = async idProduct => {
  let url = `${urlBase}${process.env.REACT_APP_URL_PRODUCTS}`
  url = url.replace(':accion', 'deleteProduct')

  const response = await axios.post(url, { idProducto: idProduct }, authHeaders())

  return handleAuthResponse(response)
}

export const productService = {
  getProductById,
  getProductsByCategory,
  getAllProducts,
  addProduct,
  editProduct,
  deleteProduct
}
